import {Injectable} from '@angular/core';
import {BehaviorSubject, map, Observable, Subject} from 'rxjs';
import {filter} from "rxjs/operators";

export interface ColumnFilter {
  readonly id: string;
  readonly value: string;
  readonly valueParsed: any;
  readonly label?: string;
  readonly isDisabled?: boolean;
  readonly isInvalid?: boolean;
}

@Injectable()
export class ColumnFiltersService {
  private readonly columnFiltersById = new Map<string, ColumnFilter>();
  private readonly columnFiltersSubject = new BehaviorSubject<Map<string, ColumnFilter>>(this.columnFiltersById);

  private readonly allColumnFiltersRemovedSubject = new Subject<undefined>();
  private readonly columnFilterRemovedSubject = new Subject<string>();

  getColumnFilters(): Observable<ColumnFilter[]> {
    return this.columnFiltersSubject.asObservable().pipe(
      map(filtersMap => [...filtersMap.values()])
    );
  }

  upsertColumnFilter(columnFilter: ColumnFilter): void {
    this.columnFiltersById.set(columnFilter?.id, columnFilter);
    this.columnFiltersSubject.next(new Map(this.columnFiltersById));
  }

  getColumnFilterIsDisabled(id: string): Observable<boolean> {
    return this.columnFiltersSubject.asObservable().pipe(
      map((filters) => filters.get(id)),
      map((filter) => filter?.isDisabled)
    );
  }

  removeColumnFilters() {
    this.columnFiltersById.clear();

    this.columnFiltersSubject.next(new Map(this.columnFiltersById));
    this.allColumnFiltersRemovedSubject.next(undefined);
  }

  columnFiltersRemoved(): Observable<undefined> {
    return this.allColumnFiltersRemovedSubject.asObservable();
  }

  removeColumnFilter(columnFilterId: string): void {
    this.columnFiltersById.delete(columnFilterId);

    this.columnFiltersSubject.next(new Map(this.columnFiltersById));
    this.columnFilterRemovedSubject.next(columnFilterId);
  }

  columnFilterRemoved(columnFilterId: string): Observable<string> {
    return this.columnFilterRemovedSubject.asObservable().pipe(
      filter(id => id === columnFilterId)
    );
  }
}
